import { Box, styled } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

import { PublicRoutes } from '@/config/routes';
import { useDomainConfig } from '@/hooks/useDomainConfig';

const HeaderWrapper = styled(Box)({
  backgroundColor: '#FFFFFF',
  position: 'sticky',
  top: 0,
  zIndex: 1000,
  width: '100%',
});

const HeaderContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  padding: '16px 24px',
  maxWidth: '1336px',
  margin: '0 auto',
  width: '100%',
});

const LogoLink = styled(Link)({
  display: 'flex',
  alignItems: 'center',
  textDecoration: 'none',
});

const LegalPageHeader: React.FC = () => {
  const domainConfig = useDomainConfig();

  return (
    <HeaderWrapper>
      <HeaderContainer>
        <LogoLink to={PublicRoutes.home}>
          <img
            src={
              domainConfig.type === 'fixdai'
                ? '/assets/brands/fixdai/logo.svg'
                : '/images/pricing/terrai-logo.svg'
            }
            alt={domainConfig.displayName}
            style={{ height: 40 }}
          />
        </LogoLink>
      </HeaderContainer>
    </HeaderWrapper>
  );
};

export default LegalPageHeader;
